import React, { useState, useRef } from "react";


const CalendarIframe = ({ url, title = "Calendar" }) => {
  const [loading, setLoading] = useState(true);
  const [iframeError, setIframeError] = useState(false);
  const iframeRef = useRef(null);

  const styles = {
    wrapper: {
      position: "relative",
      width: "100%",
      height: "100%",
      minHeight: "calc(100vh - 300px)",
    },
    iframe: {
      display: "block",
      width: "100%",
      height: "100%",
      minHeight: "calc(100vh - 300px)",
      border: "none",
      opacity: loading ? 0 : 1,
      transition: "opacity 0.4s ease",
      colorScheme: "dark",
    },
    overlay: {
      position: "absolute",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 14,
      background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
      zIndex: 2,
    },
    spinner: {
      width: 36,
      height: 36,
      border: "3px solid rgba(34,211,238,0.15)",
      borderTopColor: "#22d3ee",
      borderRadius: "50%",
      animation: "spin 0.8s linear infinite",
    },
    loadingText: {
      color: "rgba(255,255,255,0.4)",
      fontSize: "0.85rem",
    },
    errorIcon: { fontSize: "2.2rem", marginBottom: 4 },
    errorTitle: {
      fontSize: "1rem",
      fontWeight: 600,
      color: "rgba(255,255,255,0.7)",
      margin: 0,
    },
    errorDesc: {
      fontSize: "0.82rem",
      color: "rgba(255,255,255,0.35)",
      margin: 0,
      textAlign: "center",
      maxWidth: 260,
    },
    retryBtn: {
      marginTop: 8,
      padding: "10px 24px",
      borderRadius: 12,
      border: "none",
      background: "linear-gradient(135deg, #22d3ee 0%, #3b82f6 100%)",
      color: "#fff",
      fontSize: "0.85rem",
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: "0 4px 15px rgba(34,211,238,0.3)",
    },
  };

  return (
    <div style={styles.wrapper}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

      {loading && !iframeError && (
        <div style={styles.overlay}>
          <div style={styles.spinner} />
          <span style={styles.loadingText}>Loading calendar…</span>
        </div>
      )}

      {iframeError && (
        <div style={styles.overlay}>
          <div style={styles.errorIcon}>⚠</div>
          <p style={styles.errorTitle}>Couldn't load calendar</p>
          <p style={styles.errorDesc}>
            Check your connection or verify the Airtable share link is correct.
          </p>
          <button
            style={styles.retryBtn}
            onClick={() => {
              setIframeError(false);
              setLoading(true);
              if (iframeRef.current) iframeRef.current.src = url;
            }}
          >
            Retry
          </button>
        </div>
      )}

      <iframe
        ref={iframeRef}
        src={url}
        title={title}
        style={styles.iframe}
        onLoad={() => setLoading(false)}
        onError={() => { setLoading(false); setIframeError(true); }}
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
        loading="lazy"
      />
    </div>
  );
};

export default CalendarIframe;